export const ERC_EXISTS_OPTION_YES_KNOWN = 'YES_DATE_KNOWN';
export const ERC_EXISTS_OPTION_YES_UNKNOWN = 'YES_DATE_UNKNOWN';
export const ERC_EXISTS_OPTION_NO = 'NO';
